/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Shadow_OffInputs */

const fr_label_shadow_off = /** @type {(inputs: Label_Shadow_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactivée`)
};

const en_label_shadow_off = /** @type {(inputs: Label_Shadow_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

/**
* | output |
* | --- |
* | "Disabled" |
*
* @param {Label_Shadow_OffInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_shadow_off = /** @type {((inputs?: Label_Shadow_OffInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Shadow_OffInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_shadow_off(inputs)
	return en_label_shadow_off(inputs)
});